import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useMember } from "../context/MemberContext";
import { useAdminAuth } from "../context/AuthContext";
import { LogOut } from "lucide-react";

export default function Navbar() {
    const { member, clear: clearMember } = useMember();
    const { admin, logout: adminLogout } = useAdminAuth();

    const isAdmin = !!admin;
    const isMember = !!member && member !== false;

    const linkClass = ({ isActive }) =>
        `font-label text-[11px] py-2 transition-colors duration-300 ${
            isActive ? "text-[#cfa052]" : "text-[#9a958a] hover:text-[#e8e4db]"
        }`;

    const handleSignOut = async () => {
        if (isAdmin) {
            await adminLogout();
            window.location.href = "/login";
        } else if (isMember) {
            // Members enter via signed handoff from the Squad app, so we just
            // clear local identity — MemberGate will show the landing screen.
            clearMember();
        }
    };

    return (
        <header
            className="sticky top-0 z-40 backdrop-blur-md bg-[#0c0b0a]/70 border-b border-white/5"
            data-testid="main-navbar"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 h-16 flex items-center justify-between">
                <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
                    <span className="w-2 h-2 rounded-full bg-[#cfa052] shadow-[0_0_12px_rgba(207,160,82,0.6)]" />
                    <span className="font-serif-display text-xl tracking-wide text-[#e8e4db] group-hover:text-[#cfa052] transition-colors">
                        Angel <span className="italic">Squad</span>
                    </span>
                </Link>

                <nav className="hidden md:flex items-center gap-10">
                    {isMember && !isAdmin && (
                        <>
                            <NavLink to="/angels"    className={linkClass} data-testid="nav-angels">Angels</NavLink>
                            <NavLink to="/selection" className={linkClass} data-testid="nav-selection">My Angel</NavLink>
                            <NavLink to="/contact"   className={linkClass} data-testid="nav-contact">Contact</NavLink>
                        </>
                    )}
                    {isAdmin && (
                        <>
                            <NavLink to="/admin" className={linkClass} data-testid="nav-admin">Admin</NavLink>
                            <NavLink to="/angels" className={linkClass} data-testid="nav-angels">Angels</NavLink>
                        </>
                    )}
                </nav>

                <div className="flex items-center gap-4">
                    {isMember && !isAdmin && (
                        <span className="hidden sm:inline font-label text-[10px] text-[#6e6a62]" data-testid="nav-member-email">
                            {member.email || member.fullName || "Squad member"}
                        </span>
                    )}
                    {isAdmin && (
                        <span className="hidden sm:inline font-label text-[10px] text-[#cfa052]" data-testid="nav-admin-badge">
                            curator
                        </span>
                    )}
                    {(isMember || isAdmin) && (
                        <button
                            onClick={handleSignOut}
                            data-testid="nav-logout-btn"
                            className="flex items-center gap-2 text-[#9a958a] hover:text-[#cfa052] transition-colors duration-300 font-label text-[10px]"
                        >
                            <LogOut className="w-3.5 h-3.5" />
                            Sign out
                        </button>
                    )}
                </div>
            </div>
        </header>
    );
}
